import { formatDateToLocaleString } from '@/shared/utils/date-utils';

/**
 * Exports data to CSV format
 * @param data - Data to export
 * @returns CSV content
 */
export function exportToCsv(excelData: unknown[], reportName: string) {
  // Convert to CSV format for Excel compatibility
  const headers = Object.keys(excelData[0]);
  const csvContent = [
    headers.join(','),
    ...excelData.map(row => headers.map(header => `"${row[header] || '-'}"`).join(','))
  ].join('\n');

  // Add BOM for Excel to recognize UTF-8
  const BOM = '\uFEFF';
  const csvBlob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
  const csvUrl = URL.createObjectURL(csvBlob);
  const a = document.createElement('a');
  a.href = csvUrl;
  a.download = `report_${reportName}_${formatDateToLocaleString(new Date().toISOString())}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(csvUrl);
}